import { BusinessUnitType } from '../types'

export const getAllBusinessUnitsQuery = () => {
  return `query {
    businessUnits ${BusinessUnitType}
  }`
}
